module.exports = __webpack_public_path__ + "static/img/guide04.1458103.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c19/guide04.png
// module id = x8rR
// module chunks = 1